var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "position-actions" },
    [
      _c("c-button", {
        staticClass: "position-actions-button",
        attrs: {
          id: `type-actions-${_vm.type.id}`,
          tabindex: "-1",
          size: "iconic",
          icon: "menu",
        },
      }),
      _c(
        "b-popover",
        {
          attrs: {
            placement: "bottomleft",
            triggers: "click",
            target: `type-actions-${_vm.type.id}`,
          },
        },
        [
          _c("div", { staticClass: "position-actions_menu" }, [
            _c(
              "div",
              {
                staticClass: "position-actions__menu-item",
                on: {
                  click: function ($event) {
                    return _vm.$emit("edit")
                  },
                },
              },
              [
                _c("c-button", {
                  staticClass: "position-actions__menu-item-icon",
                  attrs: { icon: "edit", size: "iconic" },
                }),
                _c(
                  "div",
                  { staticClass: "position-actions__menu-item-label" },
                  [_vm._v("Редактировать")]
                ),
              ],
              1
            ),
            _c(
              "div",
              {
                staticClass: "position-actions__menu-item",
                on: {
                  click: function ($event) {
                    return _vm.$emit("archiveOperation")
                  },
                },
              },
              [
                _c("div", { staticClass: "position-actions__menu-item-icon" }, [
                  !_vm.type.isArchive
                    ? _c(
                        "svg",
                        {
                          attrs: {
                            width: "15",
                            height: "14",
                            viewBox: "0 0 15 14",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                          },
                        },
                        [
                          _c("path", {
                            attrs: {
                              d: "M6 8H9M1 1H14V5H1V1ZM2 5H13V13H2V5Z",
                              stroke: "#8E9CBB",
                              "stroke-width": "2",
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                            },
                          }),
                        ]
                      )
                    : _c(
                        "svg",
                        {
                          attrs: {
                            width: "16",
                            height: "14",
                            viewBox: "0 0 16 14",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                          },
                        },
                        [
                          _c("path", {
                            attrs: {
                              d: "M9 13C12.3137 13 15 10.3137 15 7C15 3.68629 12.3137 1 9 1C5.68629 1 3 3.68629 3 7M1 7L3 9L5 7",
                              stroke: "#8E9CBB",
                              "stroke-width": "2",
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                            },
                          }),
                        ]
                      ),
                ]),
                _c(
                  "div",
                  { staticClass: "position-actions__menu-item-label" },
                  [
                    _vm._v(
                      " " +
                        _vm._s(
                          !_vm.type.isArchive
                            ? "Переместить в архив"
                            : "Восстановить из архива"
                        ) +
                        " "
                    ),
                  ]
                ),
              ]
            ),
            _c(
              "div",
              {
                staticClass: "position-actions__menu-item",
                on: {
                  click: function ($event) {
                    return _vm.$emit("remove")
                  },
                },
              },
              [
                _c("c-button", {
                  staticClass: "position-actions__menu-item-icon",
                  attrs: { icon: "trash", size: "iconic" },
                }),
                _c(
                  "div",
                  { staticClass: "position-actions__menu-item-label" },
                  [_vm._v("Удалить")]
                ),
              ],
              1
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }